import { useQueryDetails, useQueryClient } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

import { loadIoDetails } from 'scenes/IO/sources/io';

import { details, grids } from './queryKeyFactory';

export const useLoadIoDetails = (
  { id, ioStatusBeforeDocuSigning },
  options
) => {
  const queryClient = useQueryClient();
  const { showMessage } = useScreenMessage();

  const loadIoWithCheckDocuSignStatus = async (
    { id, ioStatusBeforeDocuSigning },
    ttl = 5
  ) => {
    let io = null;
    for (let i = 0; i < ttl; i++) {
      io = await loadIoDetails({ id });
      if (io.status.id !== ioStatusBeforeDocuSigning) {
        return io;
      }
    }

    showMessage(
      'Document signing is being processed. Please refresh the page to update IO status.',
      { ttl: 0, closable: true }
    );

    return io;
  };
  return useQueryDetails(
    details(`${id}_${ioStatusBeforeDocuSigning}`),
    () =>
      ioStatusBeforeDocuSigning !== undefined
        ? loadIoWithCheckDocuSignStatus({ id, ioStatusBeforeDocuSigning })
        : loadIoDetails({ id }),
    {
      initialData: () => {
        return queryClient
          .getQueryData(grids(), { exact: false })
          ?.rows?.find((d) => d.id === id);
      },
      ...options,
    }
  );
};
